declare global {
  interface Window {
    Cookiebot?: {
      show(): void
    }
  }
}

export default function toggleCookiebotPreferences() {
  const toggleElement = document.querySelector('.js-cookie-banner-toggle')

  if (toggleElement !== null) {
    toggleElement.addEventListener('click', (event: Event) => {
      event.preventDefault()

      if (window?.Cookiebot) {
        window.Cookiebot.show()
      }
    })
  }
}
